import React from 'react';
import { Radio } from 'react-bootstrap';
import { Field } from 'redux-form';
import styled from 'styled-components';
import parseBoolean from '../../../../helpers/parseBoolean';

const BooleanFieldsGrid = styled.div`
  display: flex;
`;
const BooleanTrue = styled.div`
  margin-right: 15px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
`;
const BooleanFalse = styled.div`
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
`;
const RadioInput = styled(Radio)`
  margin-top: 0;

  > label {
    width: 100%;
    height: 60px;
    position: absolute;
    opacity: 0;
    padding: 0;
  }
`;

const RadioButton = styled.div`
  height: 60px;
  width: 100%;
  color: white;
  opacity: 1;
  font-size: 16px;
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
  min-height: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: space-around;
  border-radius: 100px;
  font-weight: bold;
  ${(props) =>
    props.isActive
      ? `
        background: #312276;
        -webkit-box-shadow: 0 4px 6px rgba(0, 0, 0, 0.7);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.7);

    `
      : `
        background: #21174F;
    `}
`;

const Button = ({ input, componentValue }) => {
  const label = componentValue ? 'Yes' : 'No';
  const checked = input.value.toString() === componentValue.toString();

  return (
    <>
      <RadioInput {...input} value={componentValue} checked={checked} />
      <RadioButton isActive={checked}>{label}</RadioButton>
    </>
  );
};

export const BooleanButtonGroup = ({ input }) => {
  return (
    <BooleanFieldsGrid>
      <BooleanTrue>
        <Field
          name={input.name}
          value={true}
          componentValue={true}
          //onChange={onChange}
          component={Button}
          normalize={parseBoolean}
          // validate={required ? isRequired : null}
        />
      </BooleanTrue>
      <BooleanFalse>
        <Field
          name={input.name}
          value={false}
          componentValue={false}
          //onChange={onChange}
          component={Button}
          normalize={parseBoolean}
          // validate={required ? isRequired : null}
        />
      </BooleanFalse>
    </BooleanFieldsGrid>
  );
};
